__turbopack_context__.v({
  "emptyContainer": "_3RF2Aq_emptyContainer",
  "socialMediaIconsContainer": "_3RF2Aq_socialMediaIconsContainer",
});
